exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-fa239bbc]{font-weight:700}.title[data-v-fa239bbc]{font-size:16px;font-weight:600;padding-bottom:10px}.survey[data-v-fa239bbc]{background-color:#fff;color:#000;padding:20px;display:flex;flex-direction:column}.suggestion[data-v-fa239bbc]{padding-top:10px;font-size:14px}", ""]);

// exports
